export const setLeftChrono = () => {

   setLeftValue();

   window.addEventListener('resize', () => {
       setLeftValue();
   });

}


function setLeftValue(){

    const chronos = document.querySelectorAll('.chrono');

    chronos?.forEach((elem) =>{

        const container = document.querySelector('.content.markdown-text');
        const containerWidth = container ? container.scrollWidth : 0;

        const windowWidth = window.innerWidth;
        const leftValue = ((windowWidth - containerWidth) / 2) * -1;

      elem.style.left = `${leftValue}px`;

    });
}